import React from 'react';
import ActualNewsletterLink from 'components/newsletters/actualNewsletterLink';
import { getProperSuccessClass } from 'services/getProperSuccessClass';

const Doi = (props) => {
  const keepCurrentIntextBoxVisible = () => {
    const intextBoxes = document.querySelectorAll('.nl-signup-box-container .nl-signup-box')

    intextBoxes.forEach((box)=>{
      box.classList.add('display-block');
    })
  };

  keepCurrentIntextBoxVisible();

  return (
    <div
      className={`shared-success-doi ${getProperSuccessClass(
        props.containerName
      )}`}
    >
      Du bist bereits zu unserem Newsletter angemeldet. Willkommen zurück.
    </div>
  );
};

export default Doi;
